import React from "react";
import TextInfo, { TEXT_DISPLAY } from "@gc-npm/components.text";
import Glyph from "@gc-npm/components.icon-glyph";
import Image from "@gc-npm/components.c-image";
import Price from "@gc-npm/components.price";
import Label from "@gc-npm/components.cms-block.cms-label";
import TextList from "@/home_components/text-list";
import getDeviceKindDependsOnViewPort from "@gc-npm/utils.common.get-device-kind-depends-on-viewport";

const createStamp = (cardData, custoStamps) => {
  const { stamp } = cardData;
  let stampToReturn;
  if (stamp && stamp != "" && custoStamps && custoStamps.length > 0) {
    try {
      const jsonStamp = JSON.parse(stamp);
      for (var i = 0; i < jsonStamp.length; i++) {
        stampToReturn = custoStamps.find((e) => e.tag === jsonStamp[i]);
        if (stampToReturn !== undefined) {
          break;
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  return stampToReturn;
};

const CardTemplate = (cardProps) => {
  if (!cardProps) {
    return null;
  }
  const { custoStamps } = cardProps;
  const headerIcon = cardProps["Glyph-1"];
  const backgroundGlyph = cardProps["Glyph-2"];
  let img = null;
  const device = getDeviceKindDependsOnViewPort();
  if (device === "MOBILE" && cardProps["Image-4"] && cardProps["Image-4"].src) {
    img = cardProps["Image-4"];
  } else {
    img = cardProps["Image-2"];
  }

  const stamp = createStamp(cardProps, custoStamps);
  const setPriority = (cardProps && cardProps.setPriority) || false;
  const imgThree = cardProps["Image-3"];
  const labelZero = cardProps["Label-0"];
  const label = cardProps["Label-1"];
  let labelTwo = cardProps["Label-2"];
  const headerPretitle = cardProps["Text-1"];
  const headerTitle = cardProps["Text-2"];
  const headerSuperTitle = cardProps["Text-6"];
  const headerPosTitle = cardProps["Text-3"];
  const price = cardProps["Price-2"];
  const priceTachado = cardProps["Price-1"];
  const prevPrice = cardProps["Text-4"];
  const postPrice = cardProps["Text-5"];
  const textList = cardProps["Characteristics-1"];
  const postCardText = cardProps["Text-7"];
  const postSavingText = cardProps["Text-8"];
  const postCardPrice = cardProps["Price-3"];
  const smallPrice = cardProps["Price-4"];
  const layout = cardProps.layout;
  const imageClassName = cardProps?.imageClassName || "";
  const cardClassName = cardProps?.cardClassName || "";
  const finalFetch = cardProps?.finalFetch;
  const name = cardProps?.name;

  const { originalPrice, librePrice, currentPrice, sizes } = cardProps;

  const showPrice =
    (price && price.amount === 0 && true) ||
    (price && price.amount) ||
    (prevPrice && prevPrice.text) ||
    (postPrice && postPrice.text) ||
    librePrice;

  if (labelTwo && labelTwo.theme == "ahorro") {
    const { originalPrice, monthlyPayment } = cardProps;
    let r2rPrice = price?.amount;
    r2rPrice = r2rPrice.toString().replace(',', '.');
    if (
      r2rPrice &&
      parseFloat(r2rPrice) >= 0 &&
      originalPrice &&
      monthlyPayment
    ) {
      const ahorro = -(
        parseFloat(monthlyPayment) * parseFloat(r2rPrice) -
        parseFloat(originalPrice)
      );
      if (ahorro >= 10) {
        const normalizedSavingForLabel = Math.round(ahorro);
        labelTwo = {
          text: `Ahorro ${normalizedSavingForLabel}€`,
          type: "promocion",
          inversed: false,
          notBorderRadius: true,
        };
      }
    }
  }

  /* editable functions */

  let colorPrice = price?.color || "movistarBlack";
  let dispo = false;
  if (layout === "dispo-product") {
    colorPrice = priceTachado?.amount != 0 ? "redHigh" : "movistarBlack";
    dispo = true;
  }

  let stampStyles = {
    justifyContent: (stamp && stamp.align) || "",
  };

  if (stamp && stamp.aspectRatio) {
    stampStyles = {
      ...stampStyles,
      "aspect-ratio": stamp.aspectRatio,
    };
  }
  if (stamp && stamp.width) {
    stampStyles = {
      ...stampStyles,
      width: `${stamp.width}px`,
    };
  }
  if (stamp && stamp.height) {
    stampStyles = {
      ...stampStyles,
      height: `${stamp.height}px`,
    };
  }

  return (
    <>
      <div className="card-container--image--stamp">
        {stamp && stamp.icon ? (
          <div className="card-container--stamp" style={stampStyles}>
            <Glyph
              id={stamp.icon}
              width={stamp.width || 200}
              height="auto"
              position="right"
            />
          </div>
        ) : (
          stamp &&
          stamp.img && (
            <div
              className="card-container--stamp"
              aria-hidden="true"
              style={{ justifyContent: stamp.align }}
            >
              <Image
                {...stamp}
                src={stamp.img}
                title={name}
                alt={name}
                priority={setPriority}
                width={stamp.width || 200}
                height={stamp.height || 0}
                sizes={sizes}
                cydata="mainImageCardIn"
              />
            </div>
          )
        )}

        {img && (img.src || img.src === "") && (
          <div
            className={`card-container--image ${imageClassName} ${stamp ? "with-stamp" : ""}`}
            aria-hidden="true"
          >
            {img && img.src && (
              <Image
                {...img}
                fill
                priority={setPriority}
                objectFit={img?.objectFit ? img.objectFit : "contain"}
                sizes={sizes}
                cyData={`Card Image-2 ${img.alt}`}
              />
            )}
          </div>
        )}
      </div>
      <div
        className={`card-container--info ${cardClassName} ${img && img.src ? "" : "full-width"}`}
      >
        {labelZero && (
          <div className="card-container--label card-container--label--zero">
            {labelZero.text && (
              <Label {...labelZero} shape="tears" cyData="Card Label-1" />
            )}
          </div>
        )}
        {(headerIcon ||
          label ||
          headerPretitle ||
          headerSuperTitle ||
          headerPosTitle ||
          showPrice) && (
          <div className="card-header">
            {headerIcon && headerIcon.id && (
              <>
                <div className="card-header--icon" data-cy="Card Glyph-1">
                  <Glyph {...headerIcon} />
                </div>
                {layout === "tariff" && (
                  <div className="card-header--icon_support"></div>
                )}
              </>
            )}
            {label && (
              <div className="card-container--label">
                {label.text && <Label {...label} cyData="Card Label-1" />}
              </div>
            )}
            {headerPretitle && headerPretitle.text && (
              <TextInfo
                className="card-header--pretitle"
                {...headerPretitle}
                cyData="Card Text-1"
              />
            )}

            {headerTitle && headerTitle.text && (
              <TextInfo
                className="card-header--title"
                {...headerTitle}
                cyData="Card Text-2"
              />
            )}

            {headerSuperTitle && headerSuperTitle.text && (
              <TextInfo
                className="card-header--supertitle"
                {...headerSuperTitle}
                cyData="Card Text-6"
              />
            )}

            {headerPosTitle && headerPosTitle.text && (
              <TextInfo
                className="card-header--subtitle"
                {...headerPosTitle}
                cyData="Card Text-3"
              />
            )}
          </div>
        )}

        {showPrice && (
          <div className="card-content">
            {labelTwo && labelTwo.text && (
              <div className="card-container--label card-container--label-two">
                <Label {...labelTwo} cyData="Card Label-2" />
                {postSavingText && postSavingText.text && (
                  <TextInfo
                    className="card-content--post-saving-text"
                    {...postSavingText}
                    cyData="Card Text-8"
                  />
                )}
              </div>
            )}

            {stamp && stamp.postSavingText && (
              <div className="card-content--stamp-text">
                <TextInfo
                  text={stamp.postSavingText}
                  size="caption"
                  color="redHigh"
                />
              </div>
            )}

            <div className="card-content--price">
              {prevPrice && prevPrice.text && price && price.amount != -1 && (
                <TextInfo
                  className="price--pre-price"
                  {...prevPrice}
                  size="caption"
                  cyData="Card Text-4"
                />
              )}
              <div className="card-content--price-block">
                {priceTachado &&
                  priceTachado.amount &&
                  priceTachado.amount != 0 && (
                    <Price
                      price={priceTachado.amount}
                      currency={priceTachado.unity}
                      quote={priceTachado.frequency}
                      cyData="Card Price-1"
                      size="caption"
                      {...priceTachado}
                    />
                  )}
                {layout &&
                  layout === "tariff" &&
                  price &&
                  (price.amount || price.amount == 0) && (
                    <div className="card-content--price_small">
                      {smallPrice && smallPrice.amount ? (
                        <Price
                          price={smallPrice.amount}
                          currency={smallPrice.unity}
                          quote={smallPrice.frequency}
                          cyData="Card Price-4"
                          {...smallPrice}
                          color={colorPrice}
                        />
                      ) : (
                        <Price
                          price={price.amount}
                          currency={price.unity}
                          quote={price.frequency}
                          cyData="Card Price-2"
                          {...price}
                          color={colorPrice}
                        />
                      )}
                    </div>
                  )}
                {price && (price.amount || price.amount == 0) && (
                  <div className="card-content--price_big">
                    <Price
                      price={price.amount}
                      currency={price.unity}
                      quote={price.frequency}
                      cyData="Card Price-2"
                      {...price}
                      color={colorPrice}
                    />
                  </div>
                )}
              </div>
              {postPrice && postPrice.text && (
                <TextInfo
                  className="price--post-price"
                  {...postPrice}
                  cyData="Card Text-5"
                />
              )}
              {currentPrice && librePrice && (
                <>
                  <hr className="price--separator" />
                  <TextInfo text="Libre" color="grey600" size="caption" />
                  <div className="price--libre-price">
                    {parseFloat(currentPrice) >= parseFloat(librePrice) && (
                      <Price
                        price={currentPrice}
                        currency="€"
                        size="xs"
                        color="movistarBlack"
                        fontType="font-bold"
                      />
                    )}
                    {librePrice &&
                      parseFloat(currentPrice) < parseFloat(librePrice) && (
                        <>
                          <Price
                            price={librePrice}
                            currency="€"
                            size="xs"
                            color="grey600"
                            decoration="line-through"
                            fontType="font-regular"
                          />
                          <Price
                            price={currentPrice}
                            currency="€"
                            size="xs"
                            color="redHigh"
                            fontType="font-bold"
                          />
                        </>
                      )}
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
      {textList && Object.entries(textList).length > 0 && (
        <div className="card-text-list">
          <TextList items={textList} />
        </div>
      )}

      {imgThree && imgThree.src && (
        <div className="card-container--image-three" aria-hidden="true">
          <Image
            {...imgThree}
            priority={setPriority}
            objectFit="contain"
            fill
            objectPosition="center"
            sizes={sizes}
            cyData={`Card Image-3 ${imgThree.alt}`}
          />
        </div>
      )}
      {backgroundGlyph && backgroundGlyph.src && (
        <div className="card-glyph">
          <object
            type="image/svg+xml"
            data={backgroundGlyph.src}
            title={
              backgroundGlyph.alt ? backgroundGlyph.alt : "Ofertas Movistar"
            }
          ></object>
        </div>
      )}
    </>
  );
};

export default CardTemplate;
